module.exports = __webpack_public_path__ + "img/tylenol_cold_head_congestion_severe.b6c2a479.png";